var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { TreeNode, TreeService } from '../tree/tree.service';
var ItemCategoryTreeCheckComponent = /** @class */ (function (_super) {
    __extends(ItemCategoryTreeCheckComponent, _super);
    function ItemCategoryTreeCheckComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            'show_contextmenu.jstree',
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'checkbox',
            'wholerow',
            'changed'
        ];
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        _this.checkIdArray = [];
        return _this;
    }
    ItemCategoryTreeCheckComponent.prototype.openAll = function () {
        $(this.element).jstree('open_all');
    };
    ItemCategoryTreeCheckComponent.prototype.closeAll = function () {
        $(this.element).jstree('close_all');
    };
    ItemCategoryTreeCheckComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.element = this.treeElement.nativeElement;
        this.init();
    };
    ItemCategoryTreeCheckComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0) {
            this.col = this.cols[0];
        }
    };
    ItemCategoryTreeCheckComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    ItemCategoryTreeCheckComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ItemCategoryTreeCheckComponent.prototype.onModeSubscribe = function (mode) {
        //this.logger.debug("-----------onModeSubscribe : "+mode);
        if (mode === 'confirm') {
            ItemCategoryTreeCheckComponent.isDisable = true;
        }
        else {
            ItemCategoryTreeCheckComponent.isDisable = false;
        }
        if (this.org_data != null) {
            this.applyToTreeData(this.org_data);
        }
    };
    ItemCategoryTreeCheckComponent.prototype.init = function () {
        var self = this;
        this.tree_data.subscribe(function (data) {
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: true,
                        data: data,
                        themes: {
                            icons: false
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        three_state: false
                    },
                    plugins: self.plugins
                });
            }
            else {
                tree.settings.core.data = data;
                tree.refresh(true, true);
            }
        });
        var events = this.all_events.filter(function (element) {
            return self.ignore_events.indexOf(element) == -1;
        });
        $(this.element).on(events.join(' '), function (e, data) {
            self.onEvent(e, e.type, data);
        });
    };
    ItemCategoryTreeCheckComponent.prototype.onSubscribe = function (rec) {
        if (rec instanceof Array) {
            this.org_data = rec;
            this.checkIdArray = [];
            this.applyToTreeData(rec);
        }
        if (typeof rec[this.col.key] !== 'undefined' && rec[this.col.key] instanceof Array) {
            this.checkIdArray = rec[this.col.key];
            this.applyToTreeData(this.org_data);
        }
    };
    ItemCategoryTreeCheckComponent.prototype.applyToTreeData = function (recs) {
        var data = [];
        for (var _i = 0, _a = recs.sort(sortByDispOrder); _i < _a.length; _i++) {
            var rec = _a[_i];
            data.push(new ItemNode(rec, this.checkIdArray));
        }
        this.setChecked(data);
        this.is_control_tree_monitor = true;
        this.tree_data.next(data);
        this.is_control_tree_monitor = false;
    };
    ItemCategoryTreeCheckComponent.prototype.setChecked = function (data) {
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var d = data_1[_i];
            if (d.data.permission) {
                var boolflg = true;
                // 3state用処理なので不要
                // if (d.children) {
                //     boolflg = this.checkedChildren(d.children);
                // }
                d.state.checked = boolflg;
            }
            if (d.children) {
                this.setChecked(d.children);
            }
        }
    };
    ItemCategoryTreeCheckComponent.prototype.checkedChildren = function (data) {
        for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
            var d = data_2[_i];
            if (!d.data.permission) {
                return false;
            }
            if (d.children) {
                if (!this.checkedChildren(d.children)) {
                    return false;
                }
            }
        }
        return true;
    };
    ItemCategoryTreeCheckComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'move_node') {
            this.beforeEvent = null;
            this.onMoveNode(rec);
        }
        else if (e2 === 'check_node') {
            this.beforeEvent = e2;
        }
        else if (e2 === 'uncheck_node') {
            this.beforeEvent = e2;
        }
        else if (e2 === 'changed') {
            this.beforeEvent = null;
            this.onChange(rec);
        }
        else if (e2 === 'activate_node') {
            if (this.beforeEvent === 'check_node') {
                this.beforeEvent = null;
                this.onCheckNode(rec);
            }
            else if (this.beforeEvent === 'uncheck_node') {
                this.beforeEvent = null;
                this.onUncheckNode(rec);
            }
        }
        else if (e2 === 'ready') {
            rec.instance.settings.checkbox.cascade = 'up+down+undetermined';
            // if (rec.instance.settings.checkbox.cascade == "up+undetermined") {
            // 	rec.instance.settings.checkbox.cascade = "up+down+undetermined";
            // 	$(this.element).jstree().redraw();
            // }
        }
        else if (e2 === 'init') {
            rec.instance.settings.checkbox.cascade = 'up+undetermined';
        }
        var items = {};
        items[this.col.key] = this.checkIdArray;
        this.action.setCompRec(this.componentName, items);
        //this.logger.debug("-----this.checkIdArray",this.checkIdArray);
    };
    ItemCategoryTreeCheckComponent.prototype.onMoveNode = function (rec) {
        var data = rec.instance._model.data;
        var root = data['#'];
        this.children(root, data);
        this.tree().redraw();
    };
    ItemCategoryTreeCheckComponent.prototype.applyToOrgData = function (rec, param) {
        var node = this.findById(rec.id, this.org_data);
        if (node != null) {
            var bool = null;
            if (param) {
                bool = param.val;
            }
            //this.logger.debug('status', node.permission +" : "+rec.state.checked+" : "+bool);
            node.permission = rec.state.checked;
            //let arrVal : String  = node.id+':'+node.label;
            var arrVal = node.id;
            // 追加
            if (this.checkIdArray.indexOf(arrVal) < 0) {
                // 自分
                if (rec.state.checked == true && bool == null) {
                    this.logger.debug('add node', node.label);
                    this.checkIdArray.push(arrVal);
                }
                // // 親
                // if(bool == true) {
                //     this.logger.debug('add parent node', node.label);
                //     this.checkIdArray.push(arrVal);
                // }
            }
            if (this.checkIdArray.indexOf(arrVal) >= 0) {
                // 自分
                if (rec.state.checked == false && bool == null) {
                    this.logger.debug('delete node', node.label);
                    this.checkIdArray.splice(this.checkIdArray.indexOf(arrVal), 1);
                }
                // // 親
                // if(bool == false) {
                //     this.logger.debug('delete parent node', node.label);
                //     this.checkIdArray.splice(this.checkIdArray.indexOf(arrVal), 1);
                // }
            }
            //if(node.permission!=true && rec.state.checked==false) {
            // if(bool==false && rec.state.checked==false) {
            //     this.logger.debug('delete node', node.label);
            //     this.checkIdArray.splice(this.checkIdArray.indexOf(node.id), 1);
            // }
            // //if(node.permission==true){
            // if(rec.state.checked){
            //     this.logger.debug('add node', node.label);
            //     this.checkIdArray.push(node.id)
            // }
            //if (param) node[param.key] = param.val;
        }
        //this.action.setRec(this.org_data);
        //this.action.setCompRec(this.componentName, { org_data: this.org_data });
    };
    ItemCategoryTreeCheckComponent.prototype.findById = function (id, data) {
        if (data == null) {
            return null;
        }
        if (data instanceof Array) {
            for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
                var d = data_3[_i];
                if (d.node_id == id) {
                    return d;
                }
                var r = this.findById(id, d.children);
                if (r != null) {
                    return r;
                }
                // r = this.findById(id, d.pages);
                // if (r != null) {
                //     return r;
                // }
                // r = this.findById(id, d.event);
                // if (r != null) {
                //     return r;
                // }
            }
        }
        return null;
    };
    ItemCategoryTreeCheckComponent.prototype.onCheckNode = function (rec) {
        //this.logger.debug("----------------onCheckNode")
        this.applyToOrgData(rec.node);
        for (var _i = 0, _a = rec.node.children_d; _i < _a.length; _i++) {
            var node = _a[_i];
            this.applyToOrgData(rec.instance._model.data[node]);
        }
        for (var _b = 0, _c = rec.node.parents; _b < _c.length; _b++) {
            var node = _c[_b];
            this.applyToOrgData(rec.instance._model.data[node], { key: 'permission', val: true });
        }
    };
    ItemCategoryTreeCheckComponent.prototype.onUncheckNode = function (rec) {
        //this.logger.debug("----------------UnCheckNode")
        this.applyToOrgData(rec.node);
        for (var _i = 0, _a = rec.node.children_d; _i < _a.length; _i++) {
            var node = _a[_i];
            this.applyToOrgData(rec.instance._model.data[node]);
        }
        for (var _b = 0, _c = rec.node.parents; _b < _c.length; _b++) {
            var node = _c[_b];
            var n = rec.instance._model.data[node];
            var boolflg = false;
            for (var _d = 0, _e = n.children; _d < _e.length; _d++) {
                var child = _e[_d];
                var c = rec.instance._model.data[child];
                if (c.state.checked) {
                    boolflg = c.state.checked;
                    break;
                }
            }
            this.applyToOrgData(n, { key: 'permission', val: boolflg });
        }
    };
    ItemCategoryTreeCheckComponent.prototype.onChange = function (rec) {
    };
    ItemCategoryTreeCheckComponent.prototype.children = function (node, data) {
        for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
            var n = _a[_i];
            if (typeof data[n].li_attr.class !== 'undefined') {
                data[n].li_attr.class = parseInt(data[n].li_attr.class) + 1;
            }
            this.children(data[n], data);
        }
    };
    ItemCategoryTreeCheckComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
    };
    ItemCategoryTreeCheckComponent.isDisable = false;
    ItemCategoryTreeCheckComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-caetgory-tree-check',
                    template: "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <dl class=\"form\">\n      <dt class=\"form_dt\">\n        <column-formtitle *ngIf=\"col\" [key]=\"'form'\" [col]=\"col\" [msg]=\"(msg | async)\"></column-formtitle>\n        <br><br>\n        <a href=\"javascript:void(0);\" (click)=\"openAll()\">{{ (msg | async)['ItemCategoryTreeComponent.openAll'] }}</a>\n        <a href=\"javascript:void(0);\" (click)=\"closeAll()\">{{ (msg | async)['ItemCategoryTreeComponent.closeAll'] }}</a>\n      </dt>\n    </dl>\n  </div>\n</div>\n<div class=\"checkTree\" #tree></div>\n"
                }] }
    ];
    /** @nocollapse */
    ItemCategoryTreeCheckComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: TreeService }
    ]; };
    ItemCategoryTreeCheckComponent.propDecorators = {
        treeElement: [{ type: ViewChild, args: ['tree',] }]
    };
    return ItemCategoryTreeCheckComponent;
}(ContentBaseComponent));
export { ItemCategoryTreeCheckComponent };
var ItemNode = /** @class */ (function (_super) {
    __extends(ItemNode, _super);
    function ItemNode(rec, checkIdArray) {
        var _this = _super.call(this, rec) || this;
        _this.type = 'Item';
        //this.logger.debug("-------------------------");
        //this.logger.debug("ItemNode rec",rec);
        if (rec['id'] != null) {
            _this.id = _this.type + "#" + rec.id;
            rec.node_id = _this.id;
        }
        //this.logger.debug("rec[permission]",rec["permission"]);
        //this.logger.debug("1",this.state.checked);
        if (rec['permission'] != null) {
            //this.logger.debug("rec.permission",rec.permission);
            _this.state.checked = rec.permission;
        }
        //this.logger.debug("2",this.state.checked);
        //this.logger.debug("ItemCategoryTreeCheckComponent.isDisable",ItemCategoryTreeCheckComponent.isDisable);
        if (ItemCategoryTreeCheckComponent.isDisable == true) {
            // if (ItemCategoryTreeCheckComponent.checkIdArray.indexOf(this.id) > 0) {
            //this.state.checked = true;
            // }
            _this.state.disabled = true;
            //this.a_attr.class = 'checkTree_disabled';
            _this.a_attr.class = 'jstree-disabled';
        }
        //this.logger.debug("3",this.state.checked);
        if (checkIdArray.indexOf(rec.id) >= 0) {
            _this.state.checked = true;
        }
        //this.logger.debug("4",this.state.checked);
        if (rec != null) {
            // if (rec["pages"] != null) {
            //     for (let page of rec["pages"].sort(sortByDispOrder)) {
            //         this.children.push(new PageNode(page));
            //     }
            // }
            if (rec['children'] != null) {
                for (var _i = 0, _a = rec['children'].sort(sortByDispOrder); _i < _a.length; _i++) {
                    var menu = _a[_i];
                    _this.children.push(new ItemNode(menu, checkIdArray));
                }
            }
        }
        return _this;
    }
    return ItemNode;
}(TreeNode));
// class PageNode extends TreeNode {
//     type: string = "PAGE";
//     li_attr: any = {class: "checkTree_page"};
//
//     constructor(rec: any) {
//         super(rec);
//         if (rec["id"] != null) {
//             this.id = `${this.type}#${rec.id}`;
//             rec.node_id = this.id;
//         }
//         if (rec["permission"] != null) {
//             this.state.checked = rec.permission;
//         }
//         if (rec != null) {
//             if (rec["event"] != null) {
//                 for (let event of rec["event"].sort(sortByDispOrder)) {
//                     this.children.push(new EventNode(event));
//                 }
//             }
//         }
//     }
// }
//
// class EventNode extends TreeNode {
//     type: string = "EVENT";
//     li_attr: any = {class: "checkTree_event"};
//
//     constructor(rec: any) {
//         super(rec);
//         if (rec["id"] != null) {
//             this.id = `${this.type}#${rec.id}`;
//             rec.node_id = this.id;
//         }
//         if (rec["permission"] != null) {
//             this.state.checked = rec.permission;
//         }
//     }
// }
var sortByDispOrder = function (n1, n2) {
    if (n1.dispOrder == null) {
        if (n2.dispOrder == null) {
            return 0;
        }
        return 1;
    }
    if (n2.dispOrder == null) {
        return -1;
    }
    if (n1.dispOrder > n2.dispOrder) {
        return 1;
    }
    if (n1.dispOrder < n2.dispOrder) {
        return -1;
    }
    return 0;
};
var ɵ0 = sortByDispOrder;
export { ɵ0 };
//# sourceMappingURL=item-category-tree-check.component.js.map